import { useAuth } from '@/hooks/auth-hooks';
import { redirectToLogin } from '@/utils/authorization-util';
import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

export default ({ children }: PropsWithChildren) => {
  const { isLogin } = useAuth();
  if (isLogin === true) {
    return children ? <>{children}</> : <Outlet />;
  } else if (isLogin === false) {
    redirectToLogin();
  }

  return <></>;
};
